import type { ReactNode } from 'react';
import { onboardingClasses } from '../../lib/onboardingTheme';
import { cn } from '../../lib/utils';

interface OnboardingShellProps {
  children: ReactNode;
  className?: string;
}

export default function OnboardingShell({ children, className }: OnboardingShellProps) {
  return (
    <div
      className={cn(
        'flex h-screen w-full overflow-hidden relative onboarding-premium-bg onboarding-premium-grain',
        onboardingClasses.root,
        className,
      )}
    >
      <div className="absolute inset-0 pointer-events-none z-0 overflow-hidden">
        <div
          className="absolute inset-0"
          style={{
            background:
              'radial-gradient(ellipse 80% 60% at 50% 40%, rgba(30, 36, 48, 0.5) 0%, transparent 70%), radial-gradient(ellipse 100% 100% at 50% 100%, #07090d 0%, #030405 100%)',
          }}
        />
        <div
          className="onboarding-ambient-glow absolute top-[15%] left-[20%] w-[45%] h-[40%] rounded-full blur-[100px]"
          style={{ background: 'rgba(255, 255, 255, 0.04)' }}
        />
        <div
          className="onboarding-ambient-glow absolute bottom-[10%] right-[15%] w-[35%] h-[35%] rounded-full blur-[90px]"
          style={{ background: 'rgba(200, 210, 225, 0.03)', animationDelay: '-11s' }}
        />
      </div>
      {children}
    </div>
  );
}
